import { mapActions, mapGetters } from 'vuex'

export default {
    data() {
      return {
      }
    },
    methods: {
        ...mapActions('conversation',['sendMessage','loadConversation', 'selectConversation', 'getGenericConversationsList']),
        ...mapGetters('login',['getUserId']),
        ...mapGetters('conversation', ['getGenericConversations']),
        
        getUserToStartChat: async function(accountInformation){
            let counterpartUserId;
            const accountInfo = await this.axios.get(`api/getAccountDetails`, {params: {accountId: accountInformation.id}})
            const accountData = accountInfo && accountInfo.data;
            if(accountData){
                if (accountData.lead_user_id){
                    counterpartUserId = accountData.lead_user_id;
                } else{
                    const account = await this.axios.get(`/api/getUsersByAccount?accountId=${accountInformation.id}`);
                    let counterPartUser = this.returnActiveUser(account.data.users);
                    counterpartUserId = counterPartUser ? counterPartUser._id : -1; 
                }
            }
            return counterpartUserId;
        },

        returnActiveUser(userList){//Take first user in account that is definitely active, otherwise take first user, this should also be removed if we have a better answer
            for(let i = 0; i < userList.length; i++) 
                if(userList[i].status_id === 100) 
                    return userList[i];
            return userList[0];
        },
        getExistingUserChat: async function(accountInformation){
            const accountUsers = await this.axios.get(`/api/getUsersByAccount?accountId=${accountInformation.id}`);

            await this.getGenericConversationsList();
            let sellersAccount;
            if (this.getGenericConversations().length > 0){
                accountUsers.data.users.map(user => { 
                    this.getGenericConversations().forEach(conversation => { 
                        if(conversation.participants.includes(user._id)){
                            sellersAccount = user._id;
                        }
                    });
                });

                if(!sellersAccount){
                    sellersAccount = await this.getUserToStartChat(accountInformation);
                    if(sellersAccount === -1){
                        console.log("This account has no sellers");
                    } else{ 
                    const message = "Hi, I'd like to open an account. Please can you advise on the next steps. Thank you very much.";
                    this.sendMessageAndStartConversation(sellersAccount, message);
                    this.goToOlfChat(sellersAccount);
                    }
                }

                return sellersAccount;
            }
        },
        sendMessageAndStartConversation(counterPartUserId, message){
            const activeUserId = this.getUserId();
            /* If there is no exisiting conversation, then start a new one */
            return this.axios.post('/api/startNewConversation', {counterPartUserId, activeUserId}).then(response =>{ 
                if (response.data.success){
                    const payload = {
                        conversationId: response.data.createdConversationId,
                        message: message
                    }
                    this.sendMessage(payload);
                }
            })
        },
        startConversation(counterPartUserId){
            const activeUserId = this.getUserId();
            return this.axios.post('/api/startNewConversation', {counterPartUserId, activeUserId});
        },
        goToOlfChat: async function(counterpartUserId){
            this.getGenericConversationsList().then(() =>{
                if (this.getGenericConversations().length > 0){
                    const conversationFoundIndex = this.getGenericConversations().findIndex((conversation, index) => 
                        conversation.otherParty._id === counterpartUserId)
    
                    if (conversationFoundIndex !== -1){
                        this.selectConversation(conversationFoundIndex)
                        this.loadConversation(this.getGenericConversations()[conversationFoundIndex]._id)
                        this.$router.push({name: 'OlfChat'})
                        return;
                    }
                }
                    const conversationIndexToSelect = this.getGenericConversations().length - 1
                    this.selectConversation(conversationIndexToSelect)
                    this.loadConversation(this.getGenericConversations()[conversationIndexToSelect]._id)
                    this.$router.push({name: 'OlfChat'})
                
            })
        }
    }
  }
  
